import {
  getLayoutPlayerColorVariant,
  getPlayerColorVariantByEngineSlot,
  type TPlayerColorVariant,
} from '../../games/player-color-variant';

import { getActiveEngineSlotFromState } from './engine-slot';

/** Keep in sync with `TurnStampOverlay.module.scss` animation durations. */
export const TURN_STAMP_VISIBLE_MS = 950;
export const TURN_STAMP_VISIBLE_REDUCED_MS = 750;

export type TTurnStampTextKey =
  | 'game.turnStamp.yourTurn'
  | 'game.turnStamp.opponentTurn';

export interface ITurnStampGameUpdate {
  gameState: unknown;
  yourTurn: boolean;
  playerSlot?: 0 | 1;
}

export function resolveMyEngineSlot(
  gameSlug: string,
  gameUpdate: ITurnStampGameUpdate | null,
  initialPlayerSlot?: 0 | 1,
): 0 | 1 | null {
  if (gameUpdate?.playerSlot === 0 || gameUpdate?.playerSlot === 1) {
    return gameUpdate.playerSlot;
  }
  if (initialPlayerSlot === 0 || initialPlayerSlot === 1) {
    return initialPlayerSlot;
  }
  if (!gameUpdate?.gameState) {
    return null;
  }
  const activeSlot = getActiveEngineSlotFromState(
    gameSlug,
    gameUpdate.gameState,
  );
  return gameUpdate.yourTurn ? activeSlot : ((1 - activeSlot) as 0 | 1);
}

export function resolveTurnStampColorVariant(
  gameSlug: string,
  gameUpdate: ITurnStampGameUpdate | null,
  initialPlayerSlot: 0 | 1 | undefined,
  isYourTurnStamp: boolean,
): TPlayerColorVariant {
  if (gameSlug === 'battleship') {
    return isYourTurnStamp
      ? getLayoutPlayerColorVariant('player1')
      : getLayoutPlayerColorVariant('player2');
  }

  const mySlot = resolveMyEngineSlot(gameSlug, gameUpdate, initialPlayerSlot);
  if (mySlot === null) {
    return isYourTurnStamp ? 'primary' : 'accent';
  }
  const myColor = getPlayerColorVariantByEngineSlot(gameSlug, mySlot);
  const opponentColor = myColor === 'primary' ? 'accent' : 'primary';
  return isYourTurnStamp ? myColor : opponentColor;
}

export function getTurnStampVisibleDurationMs(
  prefersReducedMotion: boolean,
): number {
  return prefersReducedMotion
    ? TURN_STAMP_VISIBLE_REDUCED_MS
    : TURN_STAMP_VISIBLE_MS;
}
